module.exports = __webpack_public_path__ + "static/media/mars-stroke.cdb820f2.svg";